module.exports = __webpack_public_path__ + "static/media/client_logo.c18a328f.svg";